import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';

const imageSize = 30;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }

  .caret {
    display: none;
  }

  .drp li a {
    font-size: 11px;
    padding: 3px 12px;
  }

  .drp button {
    border: none;
    background: transparent !important;
    box-shadow: none !important;
  }

  .drp button a {
    font-size: 16px;
    color: #888;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const SectionHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SectionTitle = styled.div`
  flex: 1;
  cursor: pointer;
  // padding: 6px ${dimensions.coreSpacing}px;
  font-size: 12px;
  span {
    display: block;
    font-size: 12px;
    color: ${colors.colorCoreGray};
  }
`;

const TagsStyle = styled.div`
  border-radius: 14px;
  padding: 3px 9px;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 8px;
  display: inline-block;
  line-height: 1.32857;
  background: rgb(77, 82, 142);
  color: rgb(255, 255, 255);
  border: none;
  animation: 0s ease 0s 1 normal none running none;
`;

export {
  MemberImg,
  Members,
  More,
  DataWrapperClass,
  SectionHead,
  SectionTitle,
  TagsStyle
};



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/styles.js